export default __webpack_public_path__ + "static/media/warning--railroad-crossing-with-barriers--g3.6e3df1bf.png";